import { RefList } from '../../../framework/infra'
import Contact from './Contact'

export default class Contacts extends RefList {
    static definitions = {
    }
    static ref = Contact
}